import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img10 from "../../About/images/10.jpg";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person10 = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img10} width={300} preview={false} style={{ borderRadius: 20 }} />
                </Fade>

                <Flex style={{ width: "100%", position: "relative" }} vertical>
                    <MyText strong size={"large"}>
                        Абжанова Дилара Ерлановна
                    </MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Bachelor of Engineering and Technology, Master of Engineering and Technology, Doctorate PhD Student of Computer Science
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=57994108900'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0002-7988-3971'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        ТОО "Astana IT University", Директор Центра компетенций и совершенства
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте или программе, а также характер выполняемой работы</MyText>
                <MyText size={"small"} italic>
                    Frontend-разработчик
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - написание научных статей
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - создание моделей облачной архитектуры программного комплекса, реализованного с использованием технологии микросервисов
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты, в которых принимала участие:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Проект на тему АР19678627 «Разработка информационной технологии, формирования мультиуниверситетских научных и образовательных сообществ, основанной на теории наукометрического анализа»
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Программа на тему «BR21882258 «Разработка комплекса интеллектуальных информационно-коммуникационных систем для экологического мониторинга эмиссий в окружающую среду для принятия управленческих решении в концепте углеродной нейтральности»
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Программа на тему «BR24993128 «Разработка информационно-аналитической системы для принятия решений для эффективного использования трансграничных водных ресурсов в сельскохозяйственной отрасли Жамбылского региона
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size="small">Публикации по теме проекта:</MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    1. Toxanov S. Bakytkereiuly, B., A. Neftissov (2024). Development of a database for the main stationary sources of pollution with regulation of emissions quotas. 2024 IEEE International Conference on Smart Information Systems and Technologies (SIST)
                </MyText>
                <MyText size="small" style={{ paddingLeft: 20 }}>
                    2. Toxanov , S., Sharipova, S., Biloshchytskyi, A., Abzhanova, D., & Bakytkereiuly , B. (2024) Analysis of the impact of sharding on the scalability and efficiency of blockchain technologies for the creation of information-analytical systems for environmental monitoring of emissions into the environment. Scientific Journal of Astana IT University. 18, 66–74. https://doi.org/10.37943/18VIFS4010
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    3. Andrii Biloshchytskyi, Ilyas Kazambayev Sapar Toxanov Lalita Kirichenko Svitlana Biloshchytska (2025). Development of Emission Determination Method Concept. IEEE Conference on Technologies for Sustainability (SusTech)
                </MyText>
            </Flex>
        </Flex>
    );
}